module.exports = __webpack_public_path__ + "static/media/final-09.71d3e040.svg";